import * as React from "react";
import {searchProgramSets} from "./programSetsService";
import Loading from "../../components/loading";
import {
    Alert, FormControl,
    FormGroup, Input, InputAdornment, InputLabel, MenuItem,
    Paper, Select, SelectChangeEvent,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    Box,
    Button,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import useDebounce from "../../lib/UseDebounce";
import AddBoxOutlinedIcon from '@mui/icons-material/AddBoxOutlined';
import TableHeaderRow from "../../components/TableHeaderRow";
import StripedTableRow from "../../components/StripedTableRow";
import ProgramSetUpsert from "./programSetUpsert";
import {Link as RouterLink} from "react-router-dom";

export default function ProgramSetsPage() {
    const [programSets, setProgramSets] = React.useState([] as any[]);
    const [loading, setLoading] = React.useState(true);
    const [limit, setLimit] = React.useState(100);
    const [search, setSearch] = React.useState('');
    const [programSetUpsert, setProgramSetUpsert] = React.useState<any>(null as any);
    const [count, setCount] = React.useState(0);

    React.useEffect(() => {
        document.title = "Program Sets | DN";
    }, []);

    const reload = async (nLimit: number, sSearch: string) => {
        setLoading(true);
        const p = await searchProgramSets(nLimit, sSearch);
        setProgramSets(p.programSets);
        setCount(p.count);
        setLoading(false);
    }

    React.useEffect(() => {
        reload(limit, search).then(() => {});
    }, []);

    const handleLimit = async (event: SelectChangeEvent) => {
        const l = parseInt(event.target.value as string, 10);
        setLimit(l);
        await reload(l, search);
    };

    useDebounce(() => {
        reload(limit, search).then(() => {});
        }, [search], 400
    );

    return (
        <>
            <h2>Program Sets</h2>
            <FormGroup row={true}>
                <FormControl sx={{ m: 1, minWidth: 120 }} size="small">
                    <InputLabel id="items-label">Items</InputLabel>
                    <Select
                        labelId="items-label"
                        value={limit.toString()}
                        label="Items"
                        onChange={handleLimit}
                        size={'small'}
                    >
                        <MenuItem value={100}>100</MenuItem>
                        <MenuItem value={500}>500</MenuItem>
                        <MenuItem value={1000}>1000</MenuItem>
                        <MenuItem value={2000}>2000</MenuItem>
                        <MenuItem value={10000}>10000</MenuItem>
                    </Select>
                </FormControl>
                <FormControl variant="outlined" sx={{ m: 1, minWidth: 120 }} size="small">
                    <Input
                        id="search"
                        type="text"
                        spellCheck="false"
                        placeholder="Search"
                        value={search || ''}
                        onChange={(e: any) => setSearch(e.target.value)}
                        startAdornment={<InputAdornment position="start"><SearchIcon /></InputAdornment>}
                    />
                </FormControl>

                <FormControl sx={{ m: 1, minWidth: 120 }} size="small">
                    <Button aria-label="Add" onClick={() => { setProgramSetUpsert({}) }} variant={'contained'} color={'warning'}>
                        <AddBoxOutlinedIcon />&nbsp;Create Program Set
                    </Button>
                </FormControl>
            </FormGroup>
            {loading ? <Loading/> :
                <>
                    {!programSets || programSets.length === 0 ? <Alert severity="warning">No results found</Alert> :
                        <>
                            <Box sx={{margin: '10px 0', fontWeight: 'bold', fontSize: '13px', display:"flex",}}>
                                Showing 1 to {Math.min(programSets.length, count).toLocaleString(undefined, {maximumFractionDigits: 0})} of {count.toLocaleString(undefined, {maximumFractionDigits: 0})}.
                            </Box>
                        <TableContainer component={Paper} sx={{maxWidth: 'calc(100vw - 10px)', width: 'fit-content'}}>
                            <Table size="small" sx={{width: 'auto'}}>
                                <TableHead>
                                    <TableHeaderRow>
                                        <TableCell>School</TableCell>
                                        <TableCell>Broker</TableCell>
                                        <TableCell>ID</TableCell>
                                    </TableHeaderRow>
                                </TableHead>
                                <TableBody>
                                    {programSets.map((row: any) => (
                                        <StripedTableRow key={row.id}>
                                            <TableCell>
                                                {row.school}
                                            </TableCell>
                                            <TableCell>
                                                {row.broker}
                                            </TableCell>
                                            <TableCell>
                                                <RouterLink to={`/programSets/${row.id}`}>
                                                    {row.id}
                                                </RouterLink>
                                            </TableCell>
                                        </StripedTableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                        </>
                    }
                </>
            }
            <ProgramSetUpsert programSet={programSetUpsert} setProgramSet={setProgramSetUpsert} reload={() => {reload(limit, search).then(() => {})}} />
        </>
    )
}
